import React, { useState } from 'react';
import { Star, ChevronLeft, ChevronRight, Quote } from 'lucide-react';
import { testimonials } from '../mock';

export default function Testimonials() {
  const [index, setIndex] = useState(0);
  const perView = 3;
  const max = testimonials.length - perView;

  const prev = () => setIndex(i => Math.max(0, i - 1));
  const next = () => setIndex(i => Math.min(max, i + 1));

  return (
    <section id="testimonials" className="py-24 bg-white scroll-mt-24">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-end justify-between flex-wrap gap-6">
          <div className="max-w-2xl">
            <span className="chip">Testimonials</span>
            <h2 className="mt-5 text-4xl md:text-5xl font-bold text-[#0a2540] tracking-tight leading-[1.05]">
              What our <span className="font-serif-display italic text-teal-600">customers</span> say
            </h2>
            <p className="mt-4 text-slate-600 text-lg">Real stories from real UK businesses growing with Sleek Business.</p>
          </div>
          <div className="flex items-center gap-3">
            <button aria-label="previous" onClick={prev} disabled={index===0} className="h-11 w-11 rounded-full border border-slate-300 flex items-center justify-center text-slate-700 hover:border-teal-500 hover:text-teal-600 disabled:opacity-40 disabled:cursor-not-allowed transition-colors">
              <ChevronLeft size={18}/>
            </button>
            <button aria-label="next" onClick={next} disabled={index===max} className="h-11 w-11 rounded-full border border-slate-300 flex items-center justify-center text-slate-700 hover:border-teal-500 hover:text-teal-600 disabled:opacity-40 disabled:cursor-not-allowed transition-colors">
              <ChevronRight size={18}/>
            </button>
          </div>
        </div>

        <div className="mt-14 overflow-hidden">
          <div className="flex gap-6 transition-transform duration-500" style={{ transform: `translateX(calc(-${index} * (33.333% + 8px)))` }}>
            {testimonials.map((t) => (
              <div key={t.name} className="min-w-[calc(100%-0px)] sm:min-w-[calc(50%-12px)] lg:min-w-[calc(33.333%-16px)]">
                <div className="h-full bg-slate-50 border border-slate-200 rounded-2xl p-7 relative">
                  <Quote size={32} className="text-teal-500/30 absolute top-6 right-6"/>
                  <div className="flex gap-1">
                    {Array.from({length:t.rating}).map((_,i)=>(
                      <Star key={i} size={16} className="text-amber-500 fill-amber-500"/>
                    ))}
                  </div>
                  <p className="mt-5 text-[15px] text-slate-700 leading-relaxed">“{t.text}”</p>
                  <div className="mt-6 pt-5 border-t border-slate-200 flex items-center gap-3">
                    <div className="h-10 w-10 rounded-full bg-gradient-to-br from-[#0a2540] to-teal-600 flex items-center justify-center text-white font-semibold text-sm">
                      {t.name.split(' ').map(n=>n[0]).slice(0,2).join('')}
                    </div>
                    <div>
                      <div className="text-sm font-semibold text-[#0a2540]">{t.name}</div>
                      <div className="text-xs text-slate-500">{t.role}</div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
